export default __webpack_public_path__ + "static/media/react-native.f6609acd.svg";